import React from "react";
//#region types
import { FormFieldProps, ToggleFieldExtraProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import ReadOnlyField from "../baseFields/readOnlyField";
import ToggleSwitch from "../baseFields/toggleSwitch";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

function ToggleFormField<T extends Record<string, any>>(props: FormFieldProps<T>) {
  const { name, value, handleOnChange, handleOnBlurCustom, field, readonly } = props;

  const extraProps = field.extraProps as ToggleFieldExtraProps;

  return readonly ? (
    <ReadOnlyField href={field.href} className={cssExports.readOnlyTextField}>
      {value
        ? extraProps?.customLabels?.active ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Yes)
        : extraProps?.customLabels?.inactive ??
          LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.No)}
    </ReadOnlyField>
  ) : (
    <ToggleSwitch
      checked={!!value}
      name={name}
      onChange={handleOnChange.bind(null, name)}
      onBlur={handleOnBlurCustom.bind(null, name)}
      disabled={props.disabled}
      className={field.classes?.input}
      customLabels={extraProps?.customLabels}
    />
  );
}

export default ToggleFormField;
